var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppGenericInput',_vm._b({attrs:{"component-name":"v-select","inherit-listeners":_vm.$listeners},scopedSlots:_vm._u([{key:"append-outer",fn:function(){return [_vm._t("append-outer")]},proxy:true}],null,true),model:{value:(_vm.givenValue),callback:function ($$v) {_vm.givenValue=$$v},expression:"givenValue"}},'AppGenericInput',[
    _vm.inputProps,
    {
      items: _vm.licenceCategories,
      itemText: 'name',
      itemValue: 'id',
      label: _vm.label
    }
  ],false))
}
var staticRenderFns = []

export { render, staticRenderFns }